import type { ThemeDefinition } from "./types";
import { hexToSrgb, hexToLinear } from "./palette";

export const reef: ThemeDefinition = {
  label: "Reef",
  className: "theme-reef",
  bg: "#0e2a2f",
  text: "#7de8e8",
  textMuted: `color-mix(in srgb, #7de8e8 60%, transparent)`,
  accent: "#d4883a",
  glassRgb: "10,32,38",
  border: "rgba(125,232,232,0.12)",
  borderHighlight: "rgba(125,232,232,0.22)",
  separator: "rgba(125,232,232,0.18)",
  selection: "#d4883a",
  selectionText: "#0e2a2f",
  gridColor: "#7de8e8",
  noiseOpacity: "0.05",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(125,232,232,0.15), 0 10px 0px rgba(0,0,0,0.50)",
  gpuClear: hexToSrgb("#0e2a2f"),
  gpuGridLine: hexToLinear("#7de8e8"),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear("#d4883a"),
  gpuAxisZ: hexToLinear("#7de8e8"),
  axisXColor: "#d4883a",
  axisZColor: "#7de8e8",
  font: '"Space Grotesk", sans-serif',
};
